import React from 'react';
import { ResponsiveContainer, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar, Tooltip, Legend } from 'recharts';
export function ProtocolRadarChart({
  data,
  height = 400
}) {
  return <ResponsiveContainer width="100%" height={height} data-id="element-346">
      <RadarChart cx="50%" cy="50%" outerRadius="70%" data={data} data-id="element-347">
        <PolarGrid data-id="element-348" />
        <PolarAngleAxis dataKey="axis" tick={{
        fill: '#64748b',
        fontSize: 10
      }} data-id="element-349" />
        <PolarRadiusAxis domain={[0, 5]} tick={{
        fill: '#64748b'
      }} data-id="element-350" />
        <Radar name="Protocol Score" dataKey="value" stroke="#10b981" fill="#10b981" fillOpacity={0.6} data-id="element-351" />
        <Tooltip formatter={(value, name) => [value, name]} labelFormatter={label => label} data-id="element-352" />
        <Legend data-id="element-353" />
      </RadarChart>
    </ResponsiveContainer>;
}